import { Button } from '@flowus/common/components';
import type { FC } from 'react';
import { useEffect } from 'react';
import { publicLink } from 'src/common/const';
import { useAuthentication, useRefreshAuthentication } from 'src/services/user/authentication';
import { createAnchorDomClick } from 'src/utils/dom';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { SettingModalCommon } from '../common';

export const Authentication: FC = () => {
  const { t } = useAppTranslation();
  const authentication = useAuthentication();
  const isAuthentication = authentication?.status === 2;
  const refreshAuthentication = useRefreshAuthentication();

  useEffect(() => {
    void refreshAuthentication();
  }, [refreshAuthentication]);

  const openAuthentication = () => {
    createAnchorDomClick(publicLink.authentication);
  };

  return (
    <SettingModalCommon.Item
      leftChild={
        <div className="space-y-0.5">
          <div>
            {isAuthentication
              ? t('components.setting_modal.authentication.greeting', {
                  name: authentication.name,
                  role:
                    authentication.type === 'student'
                      ? t('components.setting_modal.authentication.student')
                      : t('components.setting_modal.authentication.teacher'),
                })
              : t('components.setting_modal.authentication.title')}
          </div>
          <div className="text-t4 text-grey3">
            {isAuthentication
              ? `${authentication.schoolName}`
              : t('components.setting_modal.authentication.description')}
          </div>
        </div>
      }
      rightChild={
        <Button onClick={openAuthentication} disable={isAuthentication}>
          {isAuthentication
            ? t('components.setting_modal.authentication.authenticated')
            : t('components.setting_modal.authentication.authenticate_now')}
        </Button>
      }
    />
  );
};
